<template>
  <div class="icon-container">
    <div
      class="dropzone"
      @dragenter.prevent="openFolder"
      @dragleave="closeFolder"
      @dragover.prevent=""
      @drop="onDrop"
    />
    <!-- eslint-disable  -->
    <svg
      :width="width"
      :height="height"
      viewBox="0 0 200 135"
      id="svg8">
      <defs
        id="defs2" />
      <g id="layer1">
        <rect
          style="fill:#3ab9f9;fill-opacity:1;stroke-width:0.251247;stroke-miterlimit:4;stroke-dasharray:none"
          id="rect1402"
          width="159.71452"
          height="115.68513"
          x="3.3434505"
          y="13.538595"
          ry="5.9908838" />
        <rect
          style="fill:#3ab9f9;fill-opacity:1;stroke-width:0.251247;stroke-miterlimit:4;stroke-dasharray:none"
          id="rect1414"
          width="57.383301"
          height="21.671354"
          x="16.007559"
          y="3.207233"
          ry="5.9908876" />
        <path
          id="front-side"
          ref="frontside"
          style="fill:#3a70f9;fill-opacity:1;stroke-width:0.251247;stroke-miterlimit:4;stroke-dasharray:none"
          :d="paths[0]"
          />
      </g>
    </svg>
  </div>

</template>

<script>
import anime from 'animejs';

export default {
  name: 'FolderIcon',
  props: {
    width: {
      type: [Number, String],
      default: '100px',
    },
    height: {
      type: [Number, String],
      default: '60px',
    },
    static: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      paths: [
        'm 17.22804,19.936814 h 147.73275 c 3.31895,0 6.24856,2.68195 5.9909,5.990884 l -7.55407,97.012622 c -0.25765,3.30893 -2.67194,5.99089 -5.99089,5.99089 H 9.673975 c -3.3189504,0 -6.2485386,-2.68196 -5.9908836,-5.99089 L 11.237156,25.927698 c 0.257656,-3.308934 2.671934,-5.990884 5.990884,-5.990884 z',
        'M 42.351376,29.558517 H 190.08413 c 3.31895,0 7.15332,2.882154 5.9909,5.990884 l -32.67741,87.390919 c -1.16242,3.10873 -2.67194,5.99089 -5.99089,5.99089 H 9.673975 c -3.3189504,0 -7.1533053,-2.88216 -5.9908836,-5.99089 L 36.360492,35.549401 c 1.162423,-3.10873 2.671934,-5.990884 5.990884,-5.990884 z',
      ],
    };
  },
  mounted() {
    // this.openFolder();
  },
  methods: {
    openFolder() {
      if (this.static) return;
      anime({
        targets: this.$refs.frontside,
        skewX: ['0', '-15deg'],
        scaleY: [1, '0.8'],
        duration: 1000,
        // easing: 'easeOutExpo',
      });
    },
    closeFolder() {
      if (this.static) return;
      anime({
        targets: this.$refs.frontside,
        skewX: ['-15deg', 0],
        scaleY: ['0.8', 1],
        duration: 1000,
        // easing: 'easeOutExpo',
      });
    },
    onDrop(e) {
      if (this.static) return;
      this.$emit('on-drop', e);
      this.closeFolder();
    },
  },
};
</script>

<style lang="scss" scoped>
#front-side {
  transform-origin: center bottom;
}
.icon-container {
  position: relative;
}
.dropzone {
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>
